import $ from 'wee-dom';
import $events from 'wee-events';
import { RouteHandler } from 'wee-routes';
import $fetch from 'wee-fetch';
import '../../scripts/swiftype.js';

const $searchClose = $('.search__close');
const $searchContainer = $('.search-container');
const $searchInput = $('.search__input');
const $searchBtn = $('.search__button');
const $searchLabel = $('.search__label');
const $login = $('.login');

function openSearch() {
	$searchContainer.addClass('-active');
	setTimeout(function() {
		$searchInput[0].focus();
	}, 300);
	$searchClose.changeTabindex();
	$('.search-icon').hide();

	if ($login.hasClass('-active')) {
		$login.removeClass('-active');
		$('.login-nav').removeClass('-active');
	}
}

export function closeSearch() {
	$searchContainer.removeClass('-active');
	$searchClose.changeTabindex();
	$searchInput.changeTabindex();
	$searchBtn.changeTabindex();
	$('.search-icon').show();
}

export default new RouteHandler({
	init() {
		var search = new SwiftypeSearch({
			engineKey: 'jzxfoUWLrMLSd2HGyipc',
			inputSelector: '.js-swiftype-input',
			sections: [
				{
					title: 'Search Results'
				},
				{
					title: 'Blog Entries'
				}
			]
		});

		$searchContainer.append($('.autocomplete-suggestions'));

		$events.on({
			'.search': {
				submit(e) {
					const searchVal = $searchInput.eq(0).val();

					window.location = `https://www.abeka.com/Search.aspx#stq=${searchVal}`;

					e.preventDefault();
				}
			},
			'.search-icon': {
				click() {
					openSearch();
				},
				keydown(e) {
					if (e.keyCode === 13) {
						openSearch();
					}
				}
			},
			'.search__close': {
				click() {
					closeSearch();
				},
				keydown(e) {
					if (e.keyCode === 13 || e.keyCode === 9) {
						closeSearch();
					}
				}
			},
			'.search__input': {
				keyup(e, el) {
					if ($(el).val() !== '') {
						$searchLabel.hide();
					} else {
						$searchLabel.show();
					}
				}
			},
			'.search-container': {
				click(e) {
					e.stopPropagation();
				}
			},
			'.body': {
				click(e) {
					if (e.target !== $searchContainer && $searchContainer.hasClass('-active')
						&& e.target !== $('.search-icon')[0]) {
						closeSearch();
					}
				}
			}
		});
	}
});
